import { render } from "./assets.vue?vue&type=template&id=0adb81c9&scoped=true"
import script from "./assets.ts?vue&type=script&lang=js"
export * from "./assets.ts?vue&type=script&lang=js"

import "./assets.vue?vue&type=style&index=0&id=0adb81c9&lang=scss&scoped=true"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adb81c9"]])

export default __exports__